module.exports = __webpack_public_path__ + "static/media/folder.051cd8af.svg";